var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMystay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Stay",
    "data-name": "My Stay",
    transform: "translate(96 2277)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7643",
    "data-name": "Rectangle 7643",
    width: 64,
    height: 64,
    transform: "translate(-96 -2277)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36314",
    "data-name": "Path 36314",
    d: "M56.759,42.915V42.17H7.241v.745a3.621,3.621,0,0,1-7.241,0V27.634a8,8,0,0,1,7.987-7.987H56.013A8,8,0,0,1,64,27.634V42.915a3.621,3.621,0,0,1-7.241,0Zm2.876-3.621v3.621a.745.745,0,1,0,1.49,0V27.634a5.117,5.117,0,0,0-5.111-5.111H7.987a5.117,5.117,0,0,0-5.111,5.111V42.915a.745.745,0,0,0,1.49,0V39.294ZM48.026,18.157V14.536A2.932,2.932,0,0,0,45.1,11.607H38.549a2.932,2.932,0,0,0-2.929,2.929v3.621H28.379V14.536a2.932,2.932,0,0,0-2.928-2.929H18.9a2.932,2.932,0,0,0-2.928,2.929v3.621H6.549V3.621A3.625,3.625,0,0,1,10.169,0H53.831a3.625,3.625,0,0,1,3.621,3.621V18.157ZM45.1,8.733a5.81,5.81,0,0,1,5.8,5.8v.745h3.674V3.621a.747.747,0,0,0-.745-.745H10.169a.747.747,0,0,0-.745.745V15.281H13.1v-.745a5.81,5.81,0,0,1,5.8-5.8h6.549a5.81,5.81,0,0,1,5.8,5.8v.745h1.491v-.745a5.81,5.81,0,0,1,5.8-5.8Z",
    transform: "translate(-96 -2268)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMystay);
export default __webpack_public_path__ + "static/media/mystay.38a7ad3189757263accc1f8d972b36b9.svg";
export { ForwardRef as ReactComponent };